<script>
  // # # # # # # # # # # # # #
  //
  //  Shortlist page
  //
  // # # # # # # # # # # # # #

  // *** IMPORT
  import { onMount } from 'svelte'

  // *** COMPONENTS
  import ShortlistItem from '../Components/ShortlistItem.svelte'

  // *** PROPS
  export let title = ''
  export let endpoint = ''
  export let architecture = false
  export let gallery = false

  // *** VARIABLES
  let items = []
  let url = ''

  // *** FUNCTIONS
  function loadData() {
    url = endpoint
    fetch(url)
      .then((r) => r.json())
      .then((arr) => {
        items = arr.posts
      })
      .catch((e) => {
        console.log(e)
      })
  }

  loadData()

  // *** ON MOUNT
  onMount(async () => {
    window.scrollTo(0, 0)
  })
</script>

<style lang="scss">
  @import '../_variables.scss';

  .shortlist {
    $block: &;

    color: $black;
    width: calc(100% - 30px);
    margin-left: $main-margin;
    margin-right: $main-margin;
    margin-top: $top-space;
    margin-bottom: $bottom-space;
    display: inline-block;

    @include screen-size('small') {
      width: calc(100vw - 40px);
      margin-left: 20px;
      margin-right: 20px;
    }

    &.architecture {
      text-align: left;
    }

    &.gallery {
      text-align: right;
    }
  }
</style>

<svelte:head>
  <title>{title.toUpperCase()} | COMPLETE WORKS</title>
</svelte:head>

<div class="shortlist" class:architecture class:gallery>
  {#each items as item}
    <ShortlistItem {item} {architecture} {gallery} />
  {/each}
</div>
